import { ActionType } from "typesafe-actions";
import * as actions from "./actions";
import {
  getHallRoomsSuccess,
  getHallsSuccess,
  getHallSuccess,
} from "./actions";
import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import {
  callApiDelete,
  callApiGet,
  callApiPost,
  callApiPut,
} from "../../utils/api";
import { HallActionTypes } from "./types";
import { message } from "antd";

type GetHallsAction = ActionType<typeof actions.getHalls>;
type GetHallAction = ActionType<typeof actions.getHall>;
type CreateHallsAction = ActionType<typeof actions.createHall>;
type UpdateHallsAction = ActionType<typeof actions.updateHall>;
type DeleteHallAction = ActionType<typeof actions.deleteHall>;
type GetHallRoomsAction = ActionType<typeof actions.getHallRooms>;

function* getHalls({ payload }: GetHallsAction) {
  try {
    const response = yield call(callApiGet, `halls?school_id=${payload}`);
    yield put(getHallsSuccess(response.data));
  } catch (error: any) {
    yield put(actions.getHallsFailure(error.response.data));
  }
}

function* getHall({ payload }: GetHallAction) {
  try {
    const response = yield call(callApiGet, `halls/${payload}`);
    yield put(getHallSuccess(response.data));
  } catch (error: any) {
    yield put(actions.getHallFailure(error.response.data));
  }
}

function* createHall({ payload }: CreateHallsAction) {
  try {
    const response = yield call(
      callApiPost,
      `halls?school_id=${payload.school_id}`,
      payload
    );
    yield put(actions.createHallSuccess(response.data));
    message.success("Hall created successfully");
  } catch (error: any) {
    yield put(actions.createHallFailure(error.response.data));
    message.error("Failed to create hall. Please try again");
  }
}

function* updateHall({ payload }: UpdateHallsAction) {
  try {
    const response = yield call(callApiPut, `halls`, payload, payload.id);
    yield put(actions.updateHallSuccess(response.data));
    message.success("Hall updated successfully");
  } catch (error: any) {
    yield put(actions.updateHallFailure(error.response.data));
    message.error("Failed to update hall. Please try again");
  }
}

function* deleteHall({ payload }: DeleteHallAction) {
  try {
    const response = yield call(callApiDelete, `halls`, payload);
    yield put(actions.deleteHallSuccess(response.data));
    message.success("Hall deleted successfully");
  } catch (error: any) {
    yield put(actions.deleteHallFailure(error.response.data));
    message.error("Failed to delete hall. Please try again");
  }
}

function* getHallRooms({ payload }: GetHallRoomsAction) {
  try {
    const response = yield call(
      callApiGet,
      `halls/${payload.hall_id}/rooms?school_id=${payload.school_id}`
    );
    yield put(getHallRoomsSuccess(response.data));
  } catch (error: any) {
    yield put(actions.getHallRoomsFailure(error.response.data));
  }
}

function* watchGetHalls() {
  yield takeEvery(HallActionTypes.FETCH_HALLS_REQUEST, getHalls);
}

function* watchCreateHall() {
  yield takeEvery(HallActionTypes.CREATE_HALL_REQUEST, createHall);
}

function* watchUpdateHall() {
  yield takeEvery(HallActionTypes.UPDATE_HALL_REQUEST, updateHall);
}

function* watchGetHall() {
  yield takeEvery(HallActionTypes.FETCH_HALL_REQUEST, getHall);
}

function* watchDeleteHall() {
  yield takeEvery(HallActionTypes.DELETE_HALL_REQUEST, deleteHall);
}

export function* HallsSaga() {
  yield all([
    fork(watchGetHalls),
    fork(watchCreateHall),
    fork(watchUpdateHall),
    fork(watchGetHall),
    fork(watchDeleteHall),
  ]);
}
